function clickToSelect(cls='js-click-to-select') {
    const elems = document.getElementsByClassName(cls)
    for (let elem of elems) {
        elem.addEventListener("click", function() {            
            window?.getSelection()?.selectAllChildren(this)
            navigator.clipboard.writeText(this.textContent)
        })
    }
}

export default clickToSelect